import template from './loanVariationSummary.html';
import controller from './loanVariationSummaryCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    loanId: '<',
    familyId: '<',
    loanAppId: '<',
  },
};
